var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "chat_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#232A5C",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#chat_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#232A5C",
    d: "M4 9.334h5.334V8.001H4zm0-2h8V6.001H4zm0-2h8V4.001H4zm-2.666 9.333v-12q0-.55.391-.941.391-.392.942-.392h10.667q.55 0 .941.392.392.391.392.941v8q0 .55-.392.942a1.28 1.28 0 0 1-.941.392H4zm2.1-4h9.9v-8H2.667v8.75z"
  }))));
};
export default SvgChat;